export const enum LOGICAL_OPERATOR {
  AND = "AND",
  OR = "OR",
}

export const enum ARITHMETIC_OPERATOR {
  ADDITION = "ADD",
  SUBSTRACTION = "SUB",
  MULTIPLICATION = "MUL",
  DIVISION = "DIV",
}

export const enum RELATIONAL_OPERATOR {
  // Form Values
  "EQUAL" = "EQ",
  "NOT_EQUAL" = "NEQ",
  "GREATER_THAN" = "GT",
  "GREATER_THAN_OR_EQUAL" = "GTE",
  "LESS_THAN" = "LT",
  "LESS_THAN_OR_EQUAL" = "LTE",
  "INCLUDES" = "INC",
  "NOT_INCLUDES" = "NINC",
  "IS_ANSWERED" = "ISA",
  "IS_NOT_ANSWERED" = "ISNA",
  "EXIST" = "EXIST",
  "NOT_EXIST" = "NOT_EXIST",
  "LIES_BETWEEN" = "LIES_BETWEEN",
  // files
  "FILE_NAME_CONTAINS" = "FILE_NAME_CONTAINS",
  "HAS_FILE_TYPE" = "HAS_FILE_TYPE",
}

export const enum AGGREGATION_OPERATOR {
  SUM = "SUM",
  MEAN = "MEAN",
  MEDIAN = "MEDIAN",
  MIN = "MIN",
  MAX = "MAX",
  COUNT = "COUNT",
}

export const enum SECONDARY_RELATIONAL_OPERATOR {
  EXACT_DATE = "EXACT_DATE",
  LAST_YEAR = "LAST_YEAR",
  LAST_6_MONTHS = "LAST_6_MONTHS",
  LAST_QUARTER = "LAST_QUARTER",
  LAST_MONTH = "LAST_MONTH",
  LAST_WEEK = "LAST_WEEK",
  YESTERDAY = "YESTERDAY",
  TODAY = "TODAY",
  TOMORROW = "TOMORROW",
  THIS_WEEK = "THIS_WEEK",
  NEXT_WEEK = "NEXT_WEEK",
  THIS_MONTH = "THIS_MONTH",
  NEXT_MONTH = "NEXT_MONTH",
  THIS_QUARTER = "THIS_QUARTER",
  NEXT_QUARTER = "NEXT_QUARTER",
  NEXT_6_MONTHS = "NEXT_6_MONTHS",
  THIS_YEAR = "THIS_YEAR",
  NEXT_YEAR = "NEXT_YEAR",
  EXACT_WEEKDAY = "EXACT_WEEKDAY",
  EXACT_DAY_OF_MONTH = "EXACT_DAY_OF_MONTH",
  EXACT_DAY_OF_YEAR = "EXACT_DAY_OF_YEAR",
  EXACT_WEEK_OF_MONTH = "EXACT_WEEK_OF_MONTH",
  EXACT_WEEK_OF_YEAR = "EXACT_WEEK_OF_YEAR",
  EXACT_MONTH_OF_YEAR = "EXACT_MONTH_OF_YEAR",
  EXACT_QUARTER = "EXACT_QUARTER",
  EXACT_YEAR = "EXACT_YEAR",
}
export const SecondaryRelationalOperators = [
  SECONDARY_RELATIONAL_OPERATOR.EXACT_DATE,
  SECONDARY_RELATIONAL_OPERATOR.LAST_YEAR,
  SECONDARY_RELATIONAL_OPERATOR.LAST_6_MONTHS,
  SECONDARY_RELATIONAL_OPERATOR.LAST_QUARTER,
  SECONDARY_RELATIONAL_OPERATOR.LAST_MONTH,
  SECONDARY_RELATIONAL_OPERATOR.LAST_WEEK,
  SECONDARY_RELATIONAL_OPERATOR.YESTERDAY,
  SECONDARY_RELATIONAL_OPERATOR.TODAY,
  SECONDARY_RELATIONAL_OPERATOR.TOMORROW,
  SECONDARY_RELATIONAL_OPERATOR.THIS_WEEK,
  SECONDARY_RELATIONAL_OPERATOR.NEXT_WEEK,
  SECONDARY_RELATIONAL_OPERATOR.THIS_MONTH,
  SECONDARY_RELATIONAL_OPERATOR.NEXT_MONTH,
  SECONDARY_RELATIONAL_OPERATOR.THIS_QUARTER,
  SECONDARY_RELATIONAL_OPERATOR.NEXT_QUARTER,
  SECONDARY_RELATIONAL_OPERATOR.NEXT_6_MONTHS,
  SECONDARY_RELATIONAL_OPERATOR.THIS_YEAR,
  SECONDARY_RELATIONAL_OPERATOR.NEXT_YEAR,
  SECONDARY_RELATIONAL_OPERATOR.EXACT_WEEKDAY,
  SECONDARY_RELATIONAL_OPERATOR.EXACT_DAY_OF_MONTH,
  SECONDARY_RELATIONAL_OPERATOR.EXACT_DAY_OF_YEAR,
  SECONDARY_RELATIONAL_OPERATOR.EXACT_WEEK_OF_MONTH,
  SECONDARY_RELATIONAL_OPERATOR.EXACT_WEEK_OF_YEAR,
  SECONDARY_RELATIONAL_OPERATOR.EXACT_MONTH_OF_YEAR,
  SECONDARY_RELATIONAL_OPERATOR.EXACT_QUARTER,
  SECONDARY_RELATIONAL_OPERATOR.EXACT_YEAR,
] as const;

export const RelationalOperators = [
  RELATIONAL_OPERATOR.EQUAL,
  RELATIONAL_OPERATOR.NOT_EQUAL,
  RELATIONAL_OPERATOR.INCLUDES,
  RELATIONAL_OPERATOR.NOT_INCLUDES,
  RELATIONAL_OPERATOR.IS_ANSWERED,
  RELATIONAL_OPERATOR.IS_NOT_ANSWERED,
  RELATIONAL_OPERATOR.LIES_BETWEEN,
  RELATIONAL_OPERATOR.NOT_EXIST,
  RELATIONAL_OPERATOR.EXIST,
  RELATIONAL_OPERATOR.GREATER_THAN,
  RELATIONAL_OPERATOR.GREATER_THAN_OR_EQUAL,
  RELATIONAL_OPERATOR.LESS_THAN,
  RELATIONAL_OPERATOR.LESS_THAN_OR_EQUAL,
  RELATIONAL_OPERATOR.FILE_NAME_CONTAINS,
  RELATIONAL_OPERATOR.HAS_FILE_TYPE,
] as const;

export const AggregationOperators = [
  AGGREGATION_OPERATOR.SUM,
  AGGREGATION_OPERATOR.MEAN,
  AGGREGATION_OPERATOR.MEDIAN,
  AGGREGATION_OPERATOR.MIN,
  AGGREGATION_OPERATOR.MAX,
  AGGREGATION_OPERATOR.COUNT,
] as const;
